<template>
  <div v-if="selectedMasterClass && isOpen">
    <div class="modal fade" role="dialog" ref="vuemodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header modal-sell" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Peak Period ({{ selectedMasterClass.masterClassName }})</h4>
                <h6 v-if="timestampItem">Last Updated: {{ timestampItem }}</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="onCloseModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="modal-content-body">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="col-sm-3 divider-right pr-25">
                      <div class="summary-error" v-if="$v.model.$error">
                        This form has errors
                      </div>
                      <div class="form-group">
                        <label class="required">Peak Period</label>
                        <v-select
                          class="v-search-select"
                          :class="{
                            'field-error':
                              isSubmitted && $v.model.peakPeriodId.$error,
                          }"
                          label="title"
                          placeholder="Select peak period"
                          v-model="model.peakPeriodId"
                          :options="peakPeriods"
                          :clearable="true"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.id"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && !$v.model.peakPeriodId.required"
                        >
                          Peak Period is required
                        </small>
                      </div>
                      <div class="form-group" v-if="serviceType === 1">
                        <label class="required">Zones</label>
                        <multiselect
                          v-model="model.zones"
                          :class="{
                            'field-error':
                              isSubmitted && !$v.model.zones.required,
                          }"
                          :options="zones"
                          :multiple="true"
                          :close-on-select="false"
                          placeholder="Select zones"
                          label="label"
                          track-by="id"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && !$v.model.zones.required"
                        >
                          Zone(s) is required
                        </small>
                      </div>
                      <div class="form-group" v-else>
                        <label class="required">Group Zone</label>
                        <multiselect
                          v-model="model.groupZones"
                          :class="{
                            'field-error':
                              isSubmitted && !$v.model.groupZones.required,
                          }"
                          :options="groupZones"
                          :multiple="true"
                          :close-on-select="false"
                          placeholder="Select group zones"
                          label="label"
                          track-by="id"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && !$v.model.groupZones.required"
                        >
                          Group zone is required
                        </small>
                      </div>
                      <div class="form-group">
                        <label class="required">Rate Type</label>
                        <v-select
                          class="v-search-select"
                          placeholder="Select rate type"
                          label="text"
                          v-model="model.amountType"
                          :options="amountTypes"
                          :clearable="false"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.value"
                        />
                      </div>
                      <div class="form-group" v-if="showCurrencyField">
                        <label class="required">Currency</label>
                        <v-select
                          class="v-search-select"
                          :class="{
                            'field-error':
                              isSubmitted && !$v.model.currency.required,
                          }"
                          placeholder="Select currency"
                          label="text"
                          v-model="model.currency"
                          :options="currencies"
                          :clearable="false"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.value"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && !$v.model.currency.required"
                        >
                          Currency is required
                        </small>
                      </div>
                      <div class="form-group">
                        <label> Rate </label>
                        <currency-input
                          v-if="
                            model.amountType === 0 || model.amountType === 1
                          "
                          class="form-control"
                          :class="{
                            'field-error':
                              isSubmitted && $v.model.flatRate.$error,
                          }"
                          autocomplete="off"
                          placeholder="Enter rate"
                          v-model="model.flatRate"
                          :allow-negative="false"
                          :currency="null"
                          :locale="moneyFormat.cultureCode"
                          :precision="moneyFormat.numberOfDecimal"
                        />
                        <input
                          v-else
                          type="number"
                          name="flatRateAmountPercentage"
                          class="form-control"
                          :class="{
                            'field-error':
                              isSubmitted && $v.model.flatRate.$error,
                          }"
                          placeholder="Enter rate"
                          v-model="model.flatRate"
                          min="0"
                          step="any"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="isSubmitted && !$v.model.flatRate.minValue"
                        >
                          Min flat rate is 0
                        </small>
                      </div>
                      <div
                        class="modal-footer"
                        v-if="isAllowToCreate || isAllowToUpdate"
                      >
                        <button
                          type="button"
                          class="btn btn-default"
                          @click.prevent="onResetForm()"
                        >
                          Reset
                        </button>
                        <button
                          v-if="!isUpdate && isAllowToCreate"
                          type="button"
                          class="btn btn-primary"
                          @click.prevent="onSubmitForm()"
                        >
                          Create
                        </button>
                        <button
                          v-if="isUpdate && isAllowToUpdate"
                          type="button"
                          class="btn btn-primary"
                          @click.prevent="onSubmitForm()"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                    <div class="col-sm-9 pl-20">
                      <div class="table-modal-detail">
                        <div class="table-responsive table-accordion">
                          <table class="table table-hover">
                            <thead>
                              <tr>
                                <th class="number">No</th>
                                <th>Peak Period</th>
                                <th>
                                  {{
                                    serviceType === 1 ? "Zones" : "Group Zones"
                                  }}
                                </th>
                                <th class="text-center">Rate Type</th>
                                <th class="text-center">Rate</th>
                                <th class="text-center" style="width: 120px">
                                  Status
                                </th>
                                <th class="text-center" style="width: 100px">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in items" :key="item.id">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td>{{ item.peakPeriod.title }}</td>
                                <td>
                                  <template
                                    v-if="
                                      item.zones &&
                                      item.zones.length > 0 &&
                                      serviceType === 1
                                    "
                                  >
                                    <p
                                      v-for="(zone, idxZoneItem) in item.zones"
                                      :key="idxZoneItem"
                                    >
                                      <span class="text-muted">{{
                                        zone.group
                                      }}</span>
                                      {{ zone.name }}
                                    </p>
                                  </template>
                                  <template
                                    v-else-if="
                                      item.zoneGroups &&
                                      item.zoneGroups.length > 0 &&
                                      serviceType === 2
                                    "
                                  >
                                    <p
                                      v-for="(
                                        zone, idxZoneItem
                                      ) in item.zoneGroups"
                                      :key="idxZoneItem"
                                    >
                                      {{ zone.name }}
                                    </p>
                                  </template>
                                  <template v-else> - </template>
                                </td>
                                <td class="text-center">
                                  {{ item.amountTypeDescription }}
                                </td>
                                <td class="text-right">
                                  {{
                                    renderRateIntoTable(
                                      item.amountType,
                                      item.flatRate,
                                      item.currency
                                    )
                                  }}
                                </td>
                                <td class="text-center">
                                  <label class="cursor-pointer">
                                    <input
                                      type="checkbox"
                                      class="control-checkbox"
                                      v-model="item.isActive"
                                      :disabled="!isAllowToUpdate"
                                      @change="onChangeStatus(item)"
                                    />
                                    <span
                                      class="pl-5 font-weight-normal v-align-middle"
                                    >
                                      {{
                                        item.isActive ? "Active" : "Inactive"
                                      }}
                                    </span>
                                  </label>
                                </td>
                                <td class="text-center">
                                  <div class="button-action-wrapper">
                                    <button
                                      v-if="isAllowToUpdate"
                                      class="btn btn-default"
                                      type="button"
                                      @click="onEdit(item)"
                                    >
                                      <span>Edit</span>
                                    </button>
                                    <button
                                      v-if="isAllowToDelete"
                                      class="btn btn-default"
                                      type="button"
                                      @click="onDelete(item)"
                                    >
                                      <i class="ic-close"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" @cancel="cancelDelete" />
    <loader :content="msg" :visible="isLoading" />
  </div>
</template>

<script>
import { required, minValue, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import { AmountTypes } from "@/models/constants";
import peakPeriodService from "@/services/master/peakPeriod/peakPeriodService.js";
import sellingTariffPeakPeriodSurchargeService from "@/services/master/sellingTariff/sellingTariffPeakPeriodSurchargeService.js";

const defaultModel = {
  id: null,
  masterClassId: null,
  peakPeriodId: null,
  currency: null,
  amountType: 1, // flat
  flatRate: null,
  isActive: true,
  zones: [],
  zoneIds: [],
  groupZones: [],
  groupZoneIds: [],
};

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    showCurrencyField() {
      return this.model.amountType !== 2;
    },
    validationCurrencyField() {
      return this.model.amountType !== 2
        ? { required, maxLength: maxLength(3) }
        : {};
    },
  },
  props: ["serviceType"],
  data() {
    return {
      isSubmitted: false,
      isOpen: false,
      allPermissions: [],
      formatter: null,
      moneyFormat: null,
      selectedMasterClass: null,
      timestampItem: null,
      itemIdToBeDeleted: null,
      amountTypes: AmountTypes,
      peakPeriods: [],
      items: [],
      currencies: [],
      zones: [],
      groupZones: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    const v = {
      model: {
        peakPeriodId: { required },
        zones: { required },
        groupZones: {},
        currency: this.validationCurrencyField,
        flatRate: { minValue: minValue(0) },
      },
    };

    if (this.serviceType === 2) {
      v.model = {
        peakPeriodId: { required },
        zones: {},
        groupZones: { required },
        currency: this.validationCurrencyField,
        flatRate: { minValue: minValue(0) },
      };
    }
    return v;
  },
  created() {
    this.$eventBus.$on(
      "initializeSellingTariffPeakPeriodSurcharge",
      this.initialize
    );
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeSellingTariffPeakPeriodSurcharge");
  },
  methods: {
    async initialize(
      masterClass,
      moneyFormat,
      formatter,
      currencies,
      zones,
      groupZone
    ) {
      try {
        this.isLoading = true;
        this.isOpen = true;
        this.selectedMasterClass = masterClass;
        this.moneyFormat = moneyFormat;
        this.formatter = formatter;
        this.currencies = currencies;
        this.zones = zones;
        this.groupZones = groupZone;

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions = profile.services["BuyingTariffPeakPeriodSurcharge"];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          this.getAll().then(() => {
            this.getPeakPeriods();
            $(this.$refs.vuemodal).modal({
              backdrop: "static",
              keyboard: false,
            });
            this.onResetForm();
          });
        }
      } finally {
        this.isLoading = false;
      }
    },
    onResetForm() {
      this.isUpdate = false;
      this.timestampItem = null;
      this.clearValidation();
      this.model = Object.assign({}, defaultModel);
    },
    clearValidation() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    onCloseModal() {
      this.isOpen = false;
      $(this.$refs.vuemodal).modal("hide");
    },
    printMoney(value) {
      return this.formatter !== null
        ? this.formatter
            .format(value)
            .replace(/[a-z]{3}/i, "")
            .trim()
        : value;
    },
    async getAll() {
      this.items = await sellingTariffPeakPeriodSurchargeService.getAll(
        this.selectedMasterClass.masterClassId,
        this.serviceType
      );
    },
    async getPeakPeriods() {
      this.peakPeriods = await peakPeriodService.getAll();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await sellingTariffPeakPeriodSurchargeService.delete(
          this.itemIdToBeDeleted
        );
        this.itemIdToBeDeleted = null;

        this.getAll().then(() => {
          this.$notification.success("Successfully deleted.", {
            title: "Success",
          });
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        setTimeout(() => {
          $("body").addClass("modal-open");
        }, 500);
      }
    },
    cancelDelete() {
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
    bindModel(item) {
      this.model.id = item.id;
      this.model.masterClassId = item.masterClassId;
      this.model.peakPeriodId = item.peakPeriodId;
      this.model.currency = item.currency;
      this.model.amountType = item.amountType;
      this.model.flatRate = item.flatRate;
      this.model.isActive = item.isActive;
      this.model.zones = null;
      this.model.groupZones = null;
      if (item.zones !== null) {
        this.model.zones = this.zones.filter((array) =>
          item.zones.some((filter) => filter.id === array.id)
        );
      }
      if (item.zoneGroups !== null) {
        this.model.groupZones = this.groupZones.filter((array) =>
          item.zoneGroups.some((filter) => filter.id === array.id)
        );
      }
    },
    async onChangeStatus(item) {
      this.isLoading = true;
      this.isUpdate = true;
      this.bindModel(item);
      this.model.isActive = !!this.model.isActive;

      try {
        const payload = this.constructPayload();
        await this.submitUpdate(payload);
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    onEdit(item) {
      this.isUpdate = true;
      this.timestampItem = item.modifiedDate.stringFullDate;
      this.bindModel(item);
    },
    onDelete(item) {
      this.itemIdToBeDeleted = item.id;
      $("#deletemodal").modal();
    },
    async onSubmitForm() {
      this.isSubmitted = true;
      this.$v.model.$touch();

      if (this.$v.model.$error) {
        return;
      }

      try {
        this.isLoading = true;
        const payload = this.constructPayload();
        if (this.isUpdate) {
          await this.submitUpdate(payload);
        } else {
          await this.submitCreate(payload);
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    constructPayload() {
      const payload = Object.assign({}, defaultModel);

      if (this.isUpdate) {
        payload.id = this.model.id;
        payload.isActive = this.model.isActive;
      }

      payload.masterClassId = this.selectedMasterClass.masterClassId;
      payload.peakPeriodId = this.model.peakPeriodId;
      payload.currency = this.model.currency;
      payload.amountType = this.model.amountType;
      payload.flatRate = this.model.flatRate;
      if (this.model.zones !== null) {
        payload.zones = this.model.zones.map((zone) => zone.id);
        payload.zoneIds = this.model.zones.map((zone) => zone.id);
      }
      if (this.model.groupZones !== null) {
        payload.groupZones = this.model.groupZones.map((zone) => zone.id);
        payload.groupZoneIds = this.model.groupZones.map((zone) => zone.id);
      }
      payload.serviceType = this.serviceType;

      return payload;
    },
    async submitCreate(payload) {
      await sellingTariffPeakPeriodSurchargeService.create(payload);
      this.onResetForm();

      this.getAll().then(() => {
        this.$notification.success("Successfully created.", {
          title: "Success",
        });
      });
    },
    async submitUpdate(payload) {
      await sellingTariffPeakPeriodSurchargeService.update(payload);
      this.onResetForm();

      this.getAll().then(() => {
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
      });
    },
    renderRateIntoTable(amountType, amount, currency) {
      if (amountType === 1) {
        if (amount) {
          return `${currency} ${this.printMoney(amount)}`;
        } else {
          return "-";
        }
      }

      if (amountType === 2) {
        if (amount) {
          return `${amount} %`;
        } else {
          return "-";
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/sellingTariff/PeakPeriodSurcharge.vue